import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles((theme) => ({
  containerInputRange: {
    justifyContent: "center",
  },
  icon: {
    marginRight: "10px",
    fontSize: "20px",
  },
  gridList: {
    display: "grid",
    gridTemplateColumns: "repeat(4, 1fr)",
    gridTemplateAreas: '"item qty volume action"',
    alignItems: "center",
    padding: "0 .5rem",
    "& span": {
      "&.item": {
        gridArea: "item",
      },
      "&.qty": {
        gridArea: "qty",
        padding: "10px",
      },
      "&.volume": {
        gridArea: "volume",
        padding: "10px",
      },
    },
    "& .action": {
      gridArea: "action",
    },

    "& span:not(:first-child)": {
      textAlign: "center",
    },
    "& .listHeaderItem": {
      fontFamily: "Manrope",
      fontSize: "14px",
      fontWeight: 700,
      lineHeight: "18px",
      color: "#465869",
    },
  },
  gridListBody: {
    marginTop: "20px",
    "& > div:nth-child(even)": {
      background: "#fff",
    },
  },
  bodyListButtons: {
    display: "flex",
    textAlign: "end",
    justifyContent: "center",
    alignItems: "center",

    "& button": {
      fontSize: "20px",
      padding: ".5rem",
    },
  },
  ml12: {
    marginLeft: 12,
  },
  containerIconLink: {
    cursor: "help",
    alignItems: "flex-end",
    display: "flex",
  },
}));

export default styles;
